import { keyframes } from '@emotion/react';

export const styles = {
  Error: {
    display: 'inline-block'
  }
};
